import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";


export interface Error {
    status: boolean;
    message: string;
}

export interface AccountTransactions {
    errors: Error;
}

@Module
export default class AccountTransactionsModule extends VuexModule implements AccountTransactions {
    errors = {} as Error;
    transaction = [];
    account_transactions = [];

    // one Transaction
    get accountTransaction() {
        return this.transaction;
    }

    // with paginate for List
    get accountTransactions() {
        return this.account_transactions;
    }

    /**
     * Get Accounts Number errors
     * @returns array
     */
    get getAccountTransactionsErrors() {
        if (JSON.stringify(this.errors) === "{}") {
            this.errors.status = true;
            this.errors.message = "";
        }
        return this.errors;
    }

    @Mutation
    [Mutations.SET_ERROR](error) {
        this.errors.status = error.status;
        this.errors.message = error.message;
        if (typeof error.errors !== "undefined") {
            let txt = "";
            const size = Object.keys(error.errors).length;
            if (size > 0) {
                Object.keys(error.errors).forEach(function (key) {
                    txt += error.errors[key] + "<br />";
                });
                this.errors.message = txt;
            }
        }
    }

    /*
    * get accounts transaction with paginate
    */
    @Mutation
    [Mutations.SET_ACCOUNT_TRANSACTIONS](data) {
        this.account_transactions = data;
    }

    /*
   * get one account transaction
   */
    @Mutation
    [Mutations.SET_ACCOUNT_TRANSACTION](data) {
        this.transaction = data.data;
    }

    /*
    * get accounts transaction with paginate
    */
    @Action
    [Actions.GET_ACCOUNT_TRANSACTIONS](credentials) {
        return ApiService.get("admin/account-transactions", credentials)
            .then(({ data }) => {
                this.context.commit(Mutations.SET_ACCOUNT_TRANSACTIONS, data);
            })
            .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data);
            });
    }

        /*
    * get accounts transaction with paginate
    */
    @Action
    [Actions.GET_ACCOUNT_TRANSACTION](credentials) {
        return ApiService.get("admin/account-transactions", credentials)
            .then(({ data }) => {
                this.context.commit(Mutations.SET_ACCOUNT_TRANSACTION, data);
            })
            .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data);
            });
    }

    @Action
    [Actions.ADD_ACCOUNT_TRANSACTION](credentials) {
        return ApiService.post("admin/account-transactions", credentials)
            .then(({ data }) => {
                this.context.commit(Mutations.SET_ERROR, data);
            })
            .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data);
            });
    }

    @Action
    [Actions.EDIT_ACCOUNT_TRANSACTION](credentials) {
        return ApiService.put("admin/account-transactions/" + credentials.id, credentials)
            .then(({ data }) => {
                this.context.commit(Mutations.SET_ERROR, data);
            })
            .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data);
            });
    }

    @Action
    [Actions.DELETE_ACCOUNT_TRANSACTION](credentials) {
        console.log(credentials)
        return ApiService.delete("admin/account-transactions/" + credentials)
            .then(({ data }) => {
                this.context.commit(Mutations.SET_ERROR, data);
            })
            .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data);
            });
    }
}
